import { Flex, Select, Text } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

import { BuildViewOptions } from "@/Utils/DataLib";

const LinkViewSection = props => {
  const SetLinkedView = target => {
    const rule = props.rule.Clone();
    rule.SetInheritTemplate(target.value);
    props.setRule(rule);
  };

  return (
    <Flex direction={"column"} gap={"12px"}>
      <Text size={"small"}>
        {appstr(
          "Linked View will be applied when the top box of the subchart matches the rule criteria"
        )}
      </Text>
      <Select
        optionSize={"small"}
        id={"select-criteria-type-button-"}
        placeholder={appstr("Linked Template")}
        value={props.rule.GetInheritTemplate()}
        options={BuildViewOptions(SetLinkedView, null, props.currentTemplateId)}
      />
    </Flex>
  );
};

export default LinkViewSection;
